import ApplicationController from './application_controller'

export default class extends ApplicationController {

	static targets = [
		'item',
		'deleteButton',
	]

	connect() {
		this.updateDeleteButton()
	}

	itemTargetConnected() {
		this.updateDeleteButton()
	}

	itemTargetDisconnected() {
		this.updateDeleteButton()
	}

	updateDeleteButton() {
		if (this.getActiveItemTargets().length > 1) {
			this.deleteButtonTargets.forEach( db => db.classList.remove('d-none') )
		} else {
			this.deleteButtonTargets.forEach( db => db.classList.add('d-none') )
		}
	}

	getActiveItemTargets() {
		if (!this.hasItemTarget) { return [] }

		return this.itemTargets
			.filter( (item) => !(item.classList.contains('d-none') || item.classList.contains('mark-to-destroy')) )
	}
}
